// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-section {
    display: flex;
    align-items: center;
    margin-top: 2rem;
}
.logged_user{
    display: flex;
    align-items: left;
    font-weight: bold;
}

.labels {
    display: flex;
    flex-direction: column;
}

.bottom-section button {
    margin-left: auto;
}

.data-info {
    color: rgb(113, 113, 216);
}
table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}
table th {
  background-color: #0b2d71 !important;
  color: white;
  font-weight: bold;
}
th, td {
    border: 1px solid white;
    text-align: center;
    padding: 8px;
}
 
th {
    background-color:#0b2d71;
    font-weight: bold;
}
td a {
  color: blue;
  text-decoration: none; 
}
.progress-bar-container {
    width: 100%;
    background-color: #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 24px;
    border-radius: 4px;
}

.high-percentage {
    background-color: red !important;
}

.normal-percentage {
    background-color: green !important;
}
  `, "",{"version":3,"sources":["webpack://./src/app/modules/permanentdelegation/home/delegation/singledelegation/reviewscreen/reviewscreen.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;AACrB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".bottom-section {\n    display: flex;\n    align-items: center;\n    margin-top: 2rem;\n}\n.logged_user{\n    display: flex;\n    align-items: left;\n    font-weight: bold;\n}\n\n.labels {\n    display: flex;\n    flex-direction: column;\n}\n\n.bottom-section button {\n    margin-left: auto;\n}\n\n.data-info {\n    color: rgb(113, 113, 216);\n}\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\ntable th {\n  background-color: #0b2d71 !important;\n  color: white;\n  font-weight: bold;\n}\nth, td {\n    border: 1px solid white;\n    text-align: center;\n    padding: 8px;\n}\n \nth {\n    background-color:#0b2d71;\n    font-weight: bold;\n}\ntd a {\n  color: blue;\n  text-decoration: none; \n}\n.progress-bar-container {\n    width: 100%;\n    background-color: #e0e0e0;\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.progress-bar {\n    height: 24px;\n    border-radius: 4px;\n}\n\n.high-percentage {\n    background-color: red !important;\n}\n\n.normal-percentage {\n    background-color: green !important;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
